import SideImg from "./sideImage/sideImg";
import SideText from "./sideText/sideText";
import Navbar from "./sideText/navbar/navbar";
import MobileCV from "./mobile/MobileCV";


function Main() {
    if (window.innerWidth <= 1100) {
        return <MobileCV />;
    }
    return(
      <main className="container">
        <Navbar/>
        <SideImg/>
        <SideText/>
      </main>
    )
}
export default Main